<div class="overlay-wrapper" *ngIf="isLoading">
    <p-progressSpinner></p-progressSpinner>
</div>
<main id="content" role="main" class="main">
    <!-- Content -->
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb"><ol id="w0" class="breadcrumb"><li class="breadcrumb-item"><a href="/">{{'home'|translate}}</a></li>
<li class="breadcrumb-item active" aria-current="page">{{'requests'|translate}}</li>
</ol></nav>        </div>
                <div class="row mb-10" >
    <div class="col-lg-12 mb-3 mb-lg-5">
        <div class="card h-100">
            <!-- Header -->
            <div class="card-header card-header-content-between">
                <h3 class="card-header-title">{{'latestRequest'|translate}}</h3>

                <!-- Dropdown -->
                <div class="dropdown">
                    <a class="btn btn-white btn-sm" href="/Sections?SectionId={{SectionIdEnv}}">
                      <i class="bi-plus-lg"></i> {{ 'applyRequest' | translate }}
                    </a>
                  </div>
                  
                <!-- End Dropdown -->
            </div>
            <!-- End Header -->

            <!-- Body -->

            <div class="tabs-wrapper">
                    <ul class="nav-tabs justify-content-center pb-2">
                    <li class="nav-item tab is-active" data-role="tab" data-target="#tabs-home3">
                      {{'uncompleteRequest'|translate}}
                    </li>
                
                    <li class="nav-item tab" data-role="tab" data-target="#tabs-profile3">
                        {{'completeRequest'|translate}}
                    </li>
  
                  </ul>

                  <div class="tab-content">
                    <div class="tab-panel card-body p-0  is-active"  id="tabs-home3">
                        <div class="table-responsive">
                            <table class="table" >
                                <thead class="thead-light">
                                <tr class="text-center">
                                    <th class="fs-5">{{'applicationNumber'|translate}}</th>
                                    <th class="fs-5">{{'applicationType'|translate}}</th>
                                    <th class="fs-5">{{'status'|translate}}</th>
                                    <th class="fs-5">{{'applyDate'|translate}}</th>
                                    <th class="fs-5"></th>
                                </tr>
                                </thead>
                                <tbody class="text-center">
                               
                                 <tr class="justify-content-center align-middle" *ngFor="let item of currentServices">
                                    <td class="col-md-2 order-md-1">
                                        <span class="mb-0">
                                            {{item?.applicationNumber}}
                                        </span>
                                    </td>
        
                                    <td class="col-md-6 order-md-2">
                                        <h5>
                                            {{item?.name}}
                                        </h5>
                                    </td>
        
                                    <td class="col-md-2 order-md-3">
                                        <span class="badge bg-soft-info text-info rounded-pill fs-5">
                                            {{item?.status}}
                                        </span>
                                    </td>
        
                                    <td class="col-md-2 order-md-4">
                                        <span>
                                            {{item?.createdDate|date}}          
                                         </span>
                                    </td>
                                    <td class="col-md-2 order-md-4">

                                        <a class="btn btn-white btn-sm py-1 px-4  my-2" href="/Form?serviceId={{item?.id}}&showForm=true&serviceType=CURRENT">{{'viewForm'|translate}}</a>

                                        <br>

                                        <a class="btn btn-white btn-sm py-1 px-4  my-2" href="/{{mainPath}}/ServiceOutput?serviceId={{item?.id}}&serviceType=CURRENT">{{'output'|translate}}</a>

                                        <br>

                                        <ng-container *ngIf="item.yourTurn==true" >
                                            <a class="btn btn-white btn-sm py-1 px-4"
                                                href="/Form?serviceId={{item?.id}}">{{'completeRequestFrom'|translate}}</a>

                                                
        
                                        </ng-container>
                                  </td>
                                </tr>


                                <tr *ngFor="let item of oldCurrentServices">
                                    <td class="order-md-1">
                                        <span>
                                            {{item?.id}}
                                        </span>
                                    </td>
                                    <td class="order-md-2">
                                        <h5 style="white-space: pre-line;width: 100px; ">
                                            
                                            {{item?.title}}
                                        </h5>
                                    </td>
                                    <td class="order-md-3">
                                        <span style="white-space: pre-line;width: 100px; " class="badge bg-soft-warning text-warning rounded-pill fs-5">
                                            {{item?.status_ar}}
                                        </span>
                                    </td>
                                    <td class="order-md-4">
                                        <span style="white-space: pre-line;width: 100px; ">
                                            {{item?.created_at}}
                                        </span>
                                    </td>
                                    <td class="order-md-4">
                                        <a class="btn btn-white btn-sm py-1 px-4  my-2" (click)="openOldApplicant(item.id)" >{{'viewForm'|translate}}</a>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
    
                        </div>
                    </div>
    
                    <div class="tab-panel card-body p-0"  id="tabs-profile3">
                        <div  class="table-responsive">
                            <table class="table">
                                <thead class="thead-light">
                                    <tr class="text-center">
                                        <th class="fs-5">{{'applicationNumber'|translate}}</th>
                                        <th class="fs-5">{{'applicationType'|translate}}</th>
                                        <th class="fs-5">{{'status'|translate}}</th>
                                        <th class="fs-5">{{'applyDate'|translate}}</th>
                                        <th class="fs-5"></th>
                                    </tr>
                                </thead>
                                <tbody class="text-center">
                                    <tr class="justify-content-center align-middle" *ngFor="let item of archiveService">
                                        <td class="col-md-2 order-md-1">
                                            <span class="mb-0">{{item.applicationNumber}}</span>
                                        </td>
                                        <td class="col-md-6 order-md-2">
                                            <h5>
                                                {{item?.name}}
                                            </h5>
                                        </td>
                                        <td class="col-md-2 order-md-3">
                                            <span [ngClass]="item.typeStatus==2?'bg-soft-danger text-danger':'bg-soft-success text-success'" class="badge rounded-pill fs-5">
                                                {{item?.status}}
                                            </span>
                                        </td>
                                        <td class="col-md-2 order-md-4">
                                            <span>
                                                {{item?.createdDate|date}}
                                             </span>
                                        </td>
                                        <td class="col-md-2 order-md-4">

                                            <a class="btn btn-white btn-sm py-1 px-4 my-2" href="/Form?serviceId={{item?.id}}&showForm=true&serviceType=ARCHIVED">{{'viewForm'|translate}}</a>
        
                                            <br>

                                            <a class="btn btn-white btn-sm py-1 px-4 my-2" href="/{{mainPath}}/ServiceOutput?serviceId={{item?.id}}&serviceType=ARCHIVED">{{'output'|translate}}</a>

                                            <br>
    
                                            <ng-container *ngIf="item.yourTurn==true" >
                                                <a class="btn btn-white btn-sm py-1 px-4"
                                                    href="/Form?serviceId={{item?.id}}">{{'completeRequestFrom'|translate}}</a>
    
                                            </ng-container>

                                            
                                            <span *ngIf="item.typeStatus==2">
                                                <i class="fa fa-eye text-primary" role="button" (click)="showRejectedType(item.id)"></i>
                                            </span>
    
                                        </td>
                                    </tr>

                                    <tr *ngFor="let item of oldArchiveService">
                                        <td class="order-md-1">
                                            <span>
                                                {{item.id}}
                                            </span>
                                        </td>
                                        <td class="order-md-2">
                                            <h5 style="white-space: pre-line;width: 100px; ">
                                                {{item?.title}}
                                            </h5>
                                        </td>
                                        <td class="order-md-3">
                                            <span style="white-space: pre-line;width: 100px; " class="badge bg-soft-warning text-warning rounded-pill fs-5">
                                                {{item?.status_ar}}
                                            </span>
                                        </td>
                                        <td class="order-md-4">
                                            <span style="white-space: pre-line;width: 100px; " >
                                                {{item?.created_at}}
                                            </span>
                                        </td>
                                        <td class="order-md-4">
                                            <a class="btn btn-white btn-sm py-1 px-4  my-2" (click)="openOldApplicant(item.id)" >{{'viewForm'|translate}}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                  </div>
               
            </div>

           
            <!-- End Body -->
        </div>
    </div>
    <!-- End Col -->
</div>
    </div>
    <!-- End Content -->
</main>
